export default class ShoppingCartHelper {
  constructor(ctx) {
    this.ctx = ctx;
  }

  clear()
  {
    this.ctx.$store.dispatch("setPlShoppingList", []);
  }

  getList()
  {
    return this.ctx.$store.getters.plShoppingList;
  }

  get(item)
  {
    var index=this.find(item);
    if (index>=0)
      return this.getList[index];
    else
      return null;
  }

  getByIndex(index)
  {
    if (index>=0)
      return this.getList()[index];
    else
      return null;
  }

  add(item)
  {
    if (this.find(item)<0)
    {
      var plLocalList = this.ctx.$store.getters.plShoppingList
      plLocalList.push(item);
      this.ctx.$store.dispatch("setPlShoppingList", plLocalList);
    }
  }

  delete(item)
  {
    var index=this.find(item);
    if (index>=0)
    {
      var plLocalList = this.ctx.$store.getters.plShoppingList
      plLocalList.splice(index,1);
      this.ctx.$store.dispatch("setPlShoppingList", plLocalList);
    }
  }

  update(item)
  {
    var index=this.find(item);
    if (index>=0)
    {
      var plLocalList = this.ctx.$store.getters.plShoppingList
      plLocalList[index].bestellmenge=item.bestellmenge;
      this.ctx.$store.dispatch("setPlShoppingList", plLocalList);
    }
  }

  find(item)
  {
    var plLocalList = this.ctx.$store.getters.plShoppingList
    var entryIndex=-1;

    for(let i = 0; i < plLocalList.length; i++)
    {
      entryIndex=i;
      if (plLocalList[i].material != item.material)
        entryIndex=-1;
      if (plLocalList[i].artnr != item.artnr)
        entryIndex=-1;
      if (plLocalList[i].glgrd != item.glgrd)
        entryIndex=-1;
      if (plLocalList[i].index != item.index)
        entryIndex=-1;
      if (plLocalList[i].struktur != item.struktur)
        entryIndex=-1;
      if (plLocalList[i].innenAussen != item.innenAussen)
        entryIndex=-1;
      if (plLocalList[i].farbton != item.farbton)
        entryIndex=-1;
      if (plLocalList[i].gebinde != item.gebinde)
        entryIndex=-1;
      if (plLocalList[i].inhalt != item.inhalt)
        entryIndex=-1;
      if (plLocalList[i].anzahl != item.anzahl)
        entryIndex=-1;
      if (plLocalList[i].lagermenge != item.lagermenge)
        entryIndex=-1;
      if (plLocalList[i].r != item.r)
        entryIndex=-1;
      if (plLocalList[i].g != item.g)
        entryIndex=-1;
      if (plLocalList[i].b != item.b)
        entryIndex=-1;

      //found
      if (entryIndex>=0)
        break;
    }
    return entryIndex;
  }

}
